export const formatStatusBadge = (data) => {
    return (
        <>
            <span className="badge text-bg-info" role="button">
                {formatStatus(data)}
            </span>
        </>
    )
}

export const formatStatus = (data) => {
    let status = [
        "Pending",
        "Approved",
        "Rejected",
        "Partial Done"
    ]

    return status[Number(data.is_active) - 1]
}

export const formatAmount = (data) => {
    let amount = 0

    data?.item_dtl?.forEach(item => {
        amount += Number(item?.amount)
    })

    return amount
}